import { registerModal } from 'features/Modal/ModalRegistry'
import { ContactImportModal } from './ContactImportModal'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'CONTACT_IMPORT_MODAL'
registerModal(modalType, ContactImportModal)
export const showContactImportModal = modalProps =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {},
  })



// WEBPACK FOOTER //
// src/features/Contacts/ContactImportModal/ContactImportModal.action.ts